import angular from 'angular';
import staticViewsConfig from "./static-views.config";

let staticViewsModule = angular.module('shared.components.staticViews', [])
  .config(staticViewsConfig);

export default staticViewsModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/static-views/static-views.js
 **/